/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BaseError, IBaseError } from "../errors";

/**
 * Action Error
 */
export class ActionError extends BaseError implements IBaseError {
	//public constructor(error: string, message: string) {
	//	super(error, message);
	//}
}
